import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M17.4537 16.6667C19.0372 14.8975 20 12.5612 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 12.5612 0.962845 14.8975 2.54631 16.6667C4.37738 18.7125 7.03833 20 10 20C12.9617 20 15.6226 18.7125 17.4537 16.6667Z"
      fill="#23383A"
    />
    <g clipPath="url(#clip0_128_190)">
      <path
        d="M8.06 8.00004C8.21673 7.55449 8.5261 7.17878 8.9333 6.93946C9.3405 6.70015 9.81926 6.61267 10.2848 6.69252C10.7503 6.77236 11.1725 7.01439 11.4767 7.37573C11.7809 7.73706 11.9474 8.19439 11.9467 8.66671C11.9467 10 9.94666 10.6667 9.94666 10.6667M10 13.3334H10.0067M16.6667 10C16.6667 13.6819 13.6819 16.6667 10 16.6667C6.3181 16.6667 3.33333 13.6819 3.33333 10C3.33333 6.31814 6.3181 3.33337 10 3.33337C13.6819 3.33337 16.6667 6.31814 16.6667 10Z"
        stroke="#75F9FB"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_128_190">
        <rect width="16" height="16" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>,
  'AboutV1Icon',
);
